var _classCallCheck = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/defineProperty", "prop-types", "react", "./context"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/defineProperty"), require("prop-types"), require("react"), require("./context"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.defineProperty, a.propTypes, a.react, a.context), a.StateProvider = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e) {
  "use strict";

  var f = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.StateProvider = void 0, b = f(b), c = f(c), d = f(d), e = f(e);
  var g = e.default.Provider;

  var h =
  /*#__PURE__*/
  function (_d$default$Component) {
    _inherits(h, _d$default$Component);

    function h() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, h);

      for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
        a[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(h)).call.apply(_getPrototypeOf2, [this].concat(a))), (0, b.default)(_assertThisInitialized(_assertThisInitialized(_this)), "state", _this.props.initialState), (0, b.default)(_assertThisInitialized(_assertThisInitialized(_this)), "setCurrentState", function (a) {
        var b = _this.props.onStateChange;

        _this.setState(a, function () {
          return b(_this.state);
        });
      });
      return _this;
    }

    _createClass(h, [{
      key: "render",
      value: function render() {
        var a = this.props,
            b = a.children,
            c = a.forceFitBounds,
            e = a.setForceFitBounds;
        return d.default.createElement(g, {
          value: {
            initialState: this.state,
            setCurrentState: this.setCurrentState,
            forceFitBounds: c,
            setForceFitBounds: e
          }
        }, b);
      }
    }]);

    return h;
  }(d.default.Component);

  a.StateProvider = h, (0, b.default)(h, "propTypes", {
    onStateChange: c.default.func
  }), (0, b.default)(h, "defaultProps", {
    onStateChange: function onStateChange() {}
  });
  a.default = h;
});